import baseURL from "../baseUrl";
import { timeZone } from "../constants";
import getAccessToken from "../../accessToken";
import {
  LoginParameters,
  ResendPhoneOtpParameter,
  ResendEmailVerificationParameter,
  CheckResetPasswordParameter,
  SignupPatrameters,
  VerifyParameter,
  VerifyParameterPhoneOTP,
  VerifyPasswordResetOtpParameter,
  VerifyPasswordResetEmailOtpParameter,
  RequestPasswordResetParameter,
  ResetPasswordWithTokenParameter,
} from "./types";

class Authentication {
  async signupInitialize(data: SignupPatrameters) {
    const response = await fetch(`${baseURL}/customer/auth/register`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async verify(data: VerifyParameter) {
    const response = await fetch(`${baseURL}/customer/auth/verify-account`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async verifyPhoneOTP(data: VerifyParameterPhoneOTP) {
    const response = await fetch(`${baseURL}/customer/auth/verify-phone-otp`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data)
    });
    return response.json();
  }

  async resendEmailVerification(data: ResendEmailVerificationParameter) {
    const response = await fetch(`${baseURL}/customer/auth/resend-email-verification`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async sendPasswordChangeVerification(data: CheckResetPasswordParameter) {
    const accessToken = getAccessToken();
    const response = await fetch(
      `${baseURL}/send-password-verification`,
      {
        method: "post",
        headers: {
          timezone: timeZone,
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  }

  async verifyChangePassword(data: {email: string, otp: string}) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/passwordchange-verification`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async requestPasswordReset(data: RequestPasswordResetParameter) {
    const response = await fetch(
      `${baseURL}/customer/auth/request-password-reset`,
      {
        method: "post",
        headers: {
          timezone: timeZone,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  }

  async verifyPasswordResetOtp(data: VerifyPasswordResetOtpParameter) {
    const response = await fetch(
      `${baseURL}/customer/auth/verify-password-reset-otp`,
      {
        method: "post",
        headers: {
          timezone: timeZone,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  }

  async verifyPasswordResetEmailOtp(data: VerifyPasswordResetEmailOtpParameter) {
    const response = await fetch(
      `${baseURL}/customer/auth/verify-password-reset-email-otp`,
      {
        method: "post",
        headers: {
          timezone: timeZone,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  }

  async resetPasswordWithToken(data: ResetPasswordWithTokenParameter) {
    const response = await fetch(
      `${baseURL}/customer/auth/reset-password-with-token`,
      {
        method: "post",
        headers: {
          timezone: timeZone,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    return response.json();
  }

  async resendPhoneOTP(data: ResendPhoneOtpParameter) {
    const response = await fetch(`${baseURL}/customer/auth/resend-phone-verification`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async login(data: LoginParameters) {
    const response = await fetch(`${baseURL}/customer/auth/login`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async logout() {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/logout`, {
      method: "post",
      headers: {
        timezone: timeZone,
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.json();
  }
}
const instance = new Authentication();
export default instance;
